<template lang="pug">
  v-checkbox(
    :value="value"
    @change="$emit('input', $event)"
  )
    template(v-slot:label)
      div
        span Даю организации "{{ organization.short_name }}" согласие на обработку указанных
        a(@click="openForm")  персональных данных
        span  в соответствии с законодательством Российской Федерации"
</template>

<script>
import UserAgreementText from '@/components/InputFields/UserPrivacyAgreementText.vue';

export default {
  props: {
    value: { type: Boolean, default: false },
    attributes: { type: Array, required: true },
    organization: { type: Object, required: true },
  },
  methods: {
    openForm() {
      this.$modals.show('generic-controller', {
        title: 'Cогласие на обработку персональных данных',
        component: UserAgreementText,
        'component-props': {
          attributes: this.attributes,
          organization: this.organization,
        },
        dialogProps: {
          width: 1000,
        },
      });
    },
  },
};
</script>
